/* eslint-disable react/prop-types */
import { faFileLines } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Icon from 'components/icon';
import CopyTextButton from 'components/custom/ui/CopyTextButton';

const AttachmentItem = ({ label, value, detail, documents }) => {
  return (
    <div className={'border-bottom border-300 py-4'}>
      <div>
        <div className="d-flex justify-content-between flex-wrap gap-2 align-items-start">
          <div>
            <div className="d-flex align-items-center mb-1">
              <FontAwesomeIcon
                icon={faFileLines}
                className="me-2 fs-9 text-700"
              />
              <p className="text-1000 mb-0 lh-1">{label}</p>
            </div>
            <div
              className={'d-flex fs-9 text-700 flex-wrap align-items-center'}
            >
              <span className="fs-8 ms-3 text-primary">
                {value || 'Not Provided'}
              </span>

              {value && (
                <span>
                  <span className="text-400 mx-1">| </span>
                  <CopyTextButton text={value} label={`Copy ${value}`} />
                </span>
              )}
            </div>
            {detail ? (
              <div
                className={
                  'd-flex fs-9 text-700 flex-wrap align-items-center ps-3'
                }
              >
                {detail}
              </div>
            ) : null}
          </div>

          <div className="d-flex flex-wrap gap-2">
            {documents?.map((document, i) => (
              <a
                key={`${i}-attachment`}
                href={document.url}
                download={document.name} // Ensure the correct filename is used for download
                className="btn btn-phoenix-secondary btn-sm d-flex align-items-center"
              >
                <Icon
                  icon={'heroicons-outline:download'}
                  className="fw-bold me-2"
                  fontSize="16px"
                />
                {document.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttachmentItem;
